<mat-card>
  <h2 translate>requesDataCard.title</h2>
  <form [formGroup]="requestDataCardForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="expirationDay"
          [id]="'expirationDayCardData'"
          [dataInput]="expirationDaysList"
          [placeholder]="'requestDataCard.firstDayExpiration'"
          [isRequired]="true"
          [showErrors]="requestDataCardForm?.controls?.expirationDay?.errors"
        ></scf-custom-select-search>
      </div>
      <div fxFlex="50" fxFlex.gt-sm="25">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="modality"
          [id]="'modalityCardData'"
          [dataInput]="modalityPaymentList"
          [placeholder]="'requestDataCard.cardModality'"
          [isRequired]="true"
          [showErrors]="requestDataCardForm?.controls?.modality?.errors"
          (selectionChange)="onChangeModality()"
        ></scf-custom-select-search>
      </div>

      <!-- el campo de seleccionar cantidad se muestra en funcion de lo que se seleccione en la modalidad de tarjeta -->
      <div fxFlex="50" fxFlex.gt-sm="25" *ngIf="showSelectAmount">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="amountCard"
          [id]="'amountCardCardData'"
          [dataInput]="fixedFeeList"
          [placeholder]="'requestDataCard.selectAmount'"
          [isRequired]="true"
          [hasToTranslateValue]="true"
          [showErrors]="requestDataCardForm?.controls?.amountCard?.errors"
          (selectionChange)="onChangeAmount()"
        ></scf-custom-select-search>
      </div>

      <!-- cuando selecciones otras cantidades, o sea mango, se muestre el input de abajo -->
      <div fxFlex="50" fxFlex.gt-sm="25" *ngIf="showOtherAmount">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataCard.customAmount</mat-label>
          <input
            id="otherAmountCardData"
            matInput
            formControlName="otherAmountCard"
            maxlength="13"
            (keypress)="numberOnly($event)"
            (blur)="getFormattedAmount()"
            [(value)]="formattedAmount"
            autocomplete="off"
          />
          <mat-error *ngIf="requestDataCardForm.controls.otherAmountCard.errors?.required" translate>
            field.required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-card>
